// extracted by mini-css-extract-plugin
module.exports = {"container":"MainSearchSelectBox__container--3f2BI"};